export default __webpack_public_path__ + "static/dairy-free-taste-1-desktop-5b33505f5495fe6bf6e64f402978f8a3.png";